import { Box, SxProps, Theme, Tooltip } from '@mui/material';

const PROGRESS_BAR_HEIGHT = 24;

export type ProgressBarChartProps = Readonly<{
  value: number;
  max: number;
  tooltipLabel?: string;
  color?: string;
}>;

export const ProgressBarChart = ({ value, max, tooltipLabel, color }: ProgressBarChartProps) => {
  const fillPercentage = Math.min((value / max) * 100, 100) + 3;

  const chartContent = (
    <Box sx={progressBarContainerSx}>
      <Box
        sx={(theme) => ({
          ...filledSx(theme, color),
          width: `calc(${fillPercentage}%)`,
        })}
      />
    </Box>
  );

  if (tooltipLabel) {
    return (
      <Tooltip title={tooltipLabel} arrow>
        {chartContent}
      </Tooltip>
    );
  }

  return chartContent;
};

const progressBarContainerSx: SxProps<Theme> = ({ backrs }) => ({
  height: `${PROGRESS_BAR_HEIGHT}px`,
  width: '200px',
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  backgroundColor: backrs.colors['Beige/50'],
  borderRadius: backrs.radius['radius-xs'],
  overflow: 'hidden',
  boxSizing: 'border-box',
});

const filledSx = (theme: Theme, color?: string) => ({
  height: '100%',
  backgroundColor: color
    ? theme.backrs.colors[color as keyof typeof theme.backrs.colors]
    : theme.backrs.colors['Brand/800'],
  borderTopRightRadius: theme.backrs.radius['radius-xs'],
  borderBottomRightRadius: theme.backrs.radius['radius-xs'],
  transition: 'width 0.3s ease-in-out',
  borderRight: `1px solid ${theme.backrs.colors['Colors/Base/Black']}`,
});
